var CASHFLOW_API_URL = '/cashflow';
var CASHFLOW_TEMPLATE_API_URL = CASHFLOW_API_URL + '/template';
var CASHFLOW_STATEMENT_API_URL = CASHFLOW_API_URL + '/statement';
var ACCOUNT_PAYABLE_URL = '/payable';
var ACCOUNT_RECEIVABLE_URL = '/receivable';
var API_URL = {
    GET_SELF_PROFILE_URL: '/users/me',
    USER: {
        GET: '/users',
        GENERATE_ACCOUNT: '/users/generate-account',
        DETAIL: function (id) {
            return "/users/".concat(id);
        }
    },
    CASHFLOW_OVERVIEW: {
        GET: "".concat(CASHFLOW_API_URL, "/overview")
    },
    CASHFLOW_TEMPLATE: {
        GET: CASHFLOW_TEMPLATE_API_URL,
        POST: CASHFLOW_TEMPLATE_API_URL,
        DUPLICATE: "".concat(CASHFLOW_TEMPLATE_API_URL, "/duplicate"),
        DETAIL: function (id, subdomain) {
            var domain = subdomain ? "/".concat(subdomain) : '';
            return "".concat(CASHFLOW_TEMPLATE_API_URL, "/").concat(id) + domain;
        }
    },
    CASHFLOW_STATEMENT: {
        GET: CASHFLOW_STATEMENT_API_URL,
        POST: CASHFLOW_STATEMENT_API_URL,
        MERGE: "".concat(CASHFLOW_STATEMENT_API_URL, "/merge"),
        REQUEST: "".concat(CASHFLOW_STATEMENT_API_URL, "/request"),
        DETAIL: function (id, subdomain) {
            var domain = subdomain ? "/".concat(subdomain) : '';
            return "".concat(CASHFLOW_STATEMENT_API_URL, "/").concat(id) + domain;
        }
    },
    CASHFLOW_REQUEST: {
        GET: "".concat(CASHFLOW_API_URL, "/request"),
        POST: "".concat(CASHFLOW_API_URL, "/request")
    },
    SYSTEM_LANGUAGE: {
        GET: '/system/language',
        GET_COMMON: '/system/language/values',
        DETAIL: function (id) {
            return "/system/language/".concat(id);
        }
    },
    DEPARTMENT: {
        GET: '/department',
        GET_TREE: '/department/tree',
        DETAIL: function (id) {
            return "/department/".concat(id);
        }
    },
    CASHFLOW_ITEM: {
        GET: '/cashflow/item'
    },
    ACCOUNT_PAYABLE_OVERVIEW: {
        GET: "".concat(ACCOUNT_PAYABLE_URL, "/overview")
    },
    ACCOUNT_PAYABLE_SUPPLIER: {
        GET: "".concat(ACCOUNT_PAYABLE_URL, "/supplier")
    },
    ACCOUNT_SUPPLIER_BALANCE: {
        GET: "".concat(ACCOUNT_PAYABLE_URL, "/supplier/balance")
    },
    ACCOUNT_SUPPLIER_ITEM_LIST: {
        GET: "".concat(ACCOUNT_PAYABLE_URL, "/supplier/balance/items")
    },
    ACCOUNT_RECEIVABLE_OVERVIEW: {
        GET: "".concat(ACCOUNT_RECEIVABLE_URL, "/overview")
    },
    ACCOUNT_RECEIVABLE_CUSTOMER: {
        GET: "".concat(ACCOUNT_RECEIVABLE_URL, "/customer")
    },
    ACCOUNT_CUSTOMER_BALANCE: {
        GET: "".concat(ACCOUNT_RECEIVABLE_URL, "/customer/balance")
    },
    ACCOUNT_CUSTOMER_ITEM_LIST: {
        GET: "".concat(ACCOUNT_RECEIVABLE_URL, "/customer/balance/items")
    },
    COUNTRY: {
        GET: '/country'
    }
};
export default API_URL;
